module.exports = __webpack_public_path__ + "1791188489487/images/south-america.e828146.png";